module.exports = __webpack_public_path__ + "static/media/15UN-Habitat4.3f5d6d4e.jpg";